import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHospitalUser, faLaptopCode, faUserDoctor } from '@fortawesome/free-solid-svg-icons';

import { Reveal } from '../../../../components/Reveal/Reveal';
import { SectionHeader } from '../../../../components/SectionHeader/SectionHeader';

import ui from '../../../../styles/ui.module.css';
import st from './Pricing.module.css';

const prices = [
  {
    title: 'Для врачей',
    price: '10 т.р.',
    duration: '16 академических часов',
    icon: faUserDoctor,
  },
  {
    title: 'Для организаторов',
    price: '20 т.р.',
    duration: '20 академических часов',
    icon: faHospitalUser,
  },
  {
    title: 'Для ИТ-специалистов',
    price: '15 т.р.',
    duration: '20 академических часов',
    icon: faLaptopCode,
  },
];

export function Pricing() {
  return (
    <section className={`${ui.section} ${ui.sectionSeam} ${st.root}`}>
      <div className={ui.container}>
        <Reveal>
          <SectionHeader
            kicker="Стоимость"
            title="Стоимость курса"
            subtitle="Тариф зависит от вашей профессиональной роли, а доступ к материалам остается с вами без ограничения по времени."
          />
        </Reveal>

        <Reveal delay={0.04}>
          <div className={`${ui.card} ${st.noticeCard}`}>
            <div className={st.noticeBadge}>Важно</div>
            <div className={st.noticeTitle}>По итогам обучения все слушатели получат Сертификат о прохождении курса.</div>
            <div className={st.noticeText}>
              Слушатели, предоставившие подтверждающие документы об образовании и успешно прошедшие Итоговую аттестацию, получают Удостоверение о повышении квалификации.
            </div>
            <div className={st.noticeWarning}>
              Обращаем внимание, что Баллы непрерывного медицинского образования (НМО) за прохождение очно-заочной обучающей программы "AI в здравоохранении" не начисляются.
            </div>
          </div>
        </Reveal>

        <div className={st.grid}>
          {prices.map((item, index) => (
            <Reveal key={item.title} delay={Math.min(0.08 + index * 0.03, 0.16)}>
              <div className={`${ui.card} ${st.priceCard}`}>
                <div className={st.iconWrap} aria-hidden="true">
                  <FontAwesomeIcon icon={item.icon} />
                </div>
                <div className={st.priceLabel}>{item.title}</div>
                <div className={st.priceValue}>{item.price}</div>
                <div className={st.priceDuration}>{item.duration}</div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.18}>
          <div className={`${ui.card} ${st.accessCard}`}>
            <div className={st.accessTitle}>После оплаты</div>
            <p className={st.accessText}>
              После оплаты вы получаете бессрочный доступ к записанным лекциям и презентационным материалам.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
